import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.regexp.split";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapMutations, mapActions } from 'vuex';

var MdmSelect = function MdmSelect() {
  return import('~/components/atoms/MdmSelect.vue');
};

var SquareImage = function SquareImage() {
  return import(
  /* webpackChunkName: "square-image" */
  '~/components/atoms/Product/SquareImage.vue');
};

export default {
  name: 'TheVariantsSection',
  components: {
    MdmSelect: MdmSelect,
    SquareImage: SquareImage
  },
  props: {
    variants: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      truncated: true
    };
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale',
    sharedEnv: 'sharedEnv/getSharedEnv'
  }), {
    maxCount: function maxCount() {
      return this.isDesktop() ? 5 : 8;
    }
  }),
  methods: _objectSpread({}, mapMutations({
    setCurrentImage: 'product/SET_CURRENT_IMAGE',
    resetCurrentImage: 'product/RESET_CURRENT_IMAGE'
  }), mapActions({
    fetchProduct: 'product/fetchProduct'
  }), {
    truncatedCount: function truncatedCount(count) {
      if (this.isMobile()) {
        return 0;
      }

      return count - this.maxCount;
    },
    truncatedCountMessage: function truncatedCountMessage(count) {
      return this.$t(this.truncated ? 'show' : 'hide', {
        count: this.truncatedCount(count)
      });
    },
    fetch: function () {
      var _fetch = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(reference, options) {
        var args, _options$find, slug, _window$location, search, hash, path;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                args = {
                  alias: reference,
                  query: this.$route.query,
                  profileId: this.$cookies.get('eb-profile') ? this.$cookies.get('eb-profile').split(':')[0] : ''
                };
                _context.next = 3;
                return this.fetchProduct(args);

              case 3:
                if (window.history.replaceState) {
                  _options$find = options.find(function (option) {
                    return option.reference === reference;
                  }), slug = _options$find.slug;
                  _window$location = window.location, search = _window$location.search, hash = _window$location.hash;
                  path = "".concat(slug, "-").concat(reference, ".htm").concat(search).concat(hash);
                  window.history.replaceState('', '', path);
                }

                this.$root.$emit('change-variant');

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetch(_x, _x2) {
        return _fetch.apply(this, arguments);
      }

      return fetch;
    }(),
    tracking: function tracking(eventAction) {
      return {
        fn: 'track-event',
        data: {
          event_action: eventAction,
          event_category: 'FicheProduit',
          event_label: "".concat(window.tc_vars.product_activity, "/").concat(window.tc_vars.page_cat2, "/").concat(window.tc_vars.page_cat3, "/").concat(window.tc_vars.page_cat4, "/").concat(window.tc_vars.page_cat5)
        }
      };
    }
  })
};